/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as moment from 'moment';
import { snapping } from 'utils/ticket-utils';
import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';

import AnimationQueue from '@appLegacy/lib/ui/AnimationQueue';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

/************************************************
 *	Contains all the code related to interacting
 *	with the plan.
 *************************************************/
export default function promisePeriodHandling(scope) {
	const logger = LoggerServiceFactory.create('promisePeriodHandling');
	this.scope = scope;

	let startX;
	let endX;
	let cols;
	let lastMatched;
	let columnWidth;
	let activeLine;

	//does all the generic setup crap basically all the "start" functions will need to do
	function setup() {
		if (!scope.planAccessCheck.isAdminSync) {
			return false;
		}
		if (scope.planAccessCheck.hasRestrictedAccessSync) {
			return false;
		}
		if (!scope.pp.promisePeriodNext) {
			return false;
		}
		if (!scope.activeColumnService.columns().length) {
			return false;
		}

		startX = scope.pp.promisePeriodNext.startX;
		endX = scope.pp.promisePeriodNext.endX;
		//startXFollower = scope.pp.promisePeriodNext.startX;
		//endXFollower = scope.pp.promisePeriodNext.endX;
		cols = scope.activeColumnService.columns();
		columnWidth = scope.activeColumnService.columnWidth();
		activeLine = cols[0].origFinishX;

		return true;
	}

	this.dragStart = function (event, currentElement) {
		if (!setup()) {
			return false;
		}
	};

	this.drag = function (event, currentElement) {
		//if(scope.planAccessCheck.hasRestrictedAccessSync) { return false; }

		let dx = event.deltaX / scope.hud.z;

		AnimationQueue(function () {
			let hit = snapping(endX + dx, [cols], 500, [
				function (item) {
					return item.origFinishX;
				},
			]);
			if (hit) {
				scope.pp.drawSimple(hit.loc - (endX - startX), hit.loc, 'promisePeriod');
				lastMatched = hit;
			}
			// var otherX = hit.loc + Math.abs(endX-startX);
			// if(otherX > scope.activeLine.$value){otherX = scope.activeLine.$value;}

			// scope.pp.drawSimple(hit.loc, otherX);
			// lastMatched = hit;
		}, 'dragPromisePeriod');
	};

	this.dragEnd = function (event, currentElement) {
		//if(scope.planAccessCheck.hasRestrictedAccessSync) { return false; }

		if (lastMatched) {
			//var change = moment(lastMatched.item.activeDay).subtract(scope.pp.promiseLength, 'days');
			//scope.pp.setCurrentPeriod(change.format('YYYY-MM-DD'), lastMatched.item.activeDay);
			logger.log('lastMatched', lastMatched);

			// var startDate = moment(lastMatched.item.activeDay).add(1,'days');
			// var changeAmount = startDate.diff(scope.pp.currentPromise.startDate, 'days');

			// var endDate = moment(scope.pp.currentPromise.endDate).add(changeAmount,'days').format('YYYY-MM-DD');
			// if(endDate > scope.activeLineDate.$value){endDate = scope.activeLineDate.$value;}
			// scope.pp.setCurrentPeriod(startDate.format('YYYY-MM-DD'), endDate);
		} else {
			scope.pp.draw();
		}
	};

	let edgeToDrag = 'right';

	this.scaleStart = function (event, currentElement, edge) {
		if (!setup()) {
			return false;
		}
		edgeToDrag = edge || 'right';
	};
	this.scale = function (event, currentElement) {
		let dx = event.deltaX / scope.hud.z;
		if (
			(edgeToDrag === 'right' && endX + dx < startX + 145) ||
			(edgeToDrag === 'left' && startX + dx > endX - 145)
		) {
			return;
		}

		AnimationQueue(function () {
			let x = edgeToDrag === 'right' ? endX + dx : startX + dx;
			let hit = snapping(x, [cols], 500, [
				function (item) {
					return item.origFinishX;
				},
			]);

			if (edgeToDrag === 'right') {
				scope.pp.drawSimple(startX, hit.loc, 'promisePeriodNext');
				//scope.pp.drawSimple(hit.loc, Math.min(hit.loc + (hit.loc - startX), activeLine), "promisePeriodNext");

				//scope.pp.drawSimple(hit.loc - (hit.loc - startX) *2, hit.loc - (hit.loc - startX), "promisePeriodPrevious");
			} else {
				scope.pp.drawSimple(hit.loc, endX, 'promisePeriodNext');
				//scope.pp.drawSimple(endX, Math.min(endX + (endX - hit.loc),activeLine), "promisePeriodNext");

				//scope.pp.drawSimple(hit.loc - (endX - hit.loc), hit.loc, "promisePeriodPrevious");
				//logger.log('eh', hit.loc, hit.loc - (hit.loc + endX));
			}
			lastMatched = hit;
		}, 'dragPromisePeriod');
	};
	this.scaleEnd = function (event, currentElement) {
		if (lastMatched) {
			let change = moment(lastMatched.item.activeDay);
			if (change > scope.activeLineDate.$value) {
				change = scope.activeLineDate.$value;
			}
			if (edgeToDrag === 'right') {
				scope.pp.updateCurrentPeriod({
					startDate: scope.pp.currentPromise.startDate,
					endDate: change.format('YYYY-MM-DD'),
				});
			} else {
				let formattedChange = moment(change).add(1, 'days').format('YYYY-MM-DD');
				scope.pp.updateCurrentPeriod({
					startDate: formattedChange,
					endDate: scope.pp.currentPromise.endDate,
				});
			}
			analyticsEventsService.promisePeriodDragged(scope.legacyState.planId);
		} else {
			scope.pp.draw();
		}
	};
}
